const AcademyUserBorder = () => {
  return <svg width="460" height="325" viewBox="9 7 454 308" fill="none" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="AcademyUserBorder" data-sentry-source-file="academy_user_border.tsx">
      <mask id="mask0_172_107" style={{
      maskType: "alpha"
    }} maskUnits="userSpaceOnUse" x="0" y="0" width="458" height="320" data-sentry-element="mask" data-sentry-source-file="academy_user_border.tsx">
        <rect width="458" height="320" rx="24" fill="#D9D9D9" data-sentry-element="rect" data-sentry-source-file="academy_user_border.tsx" />
      </mask>
      <g mask="url(#mask0_172_107)" data-sentry-element="g" data-sentry-source-file="academy_user_border.tsx">
        <foreignObject x="28.8316" y="214.4" width="529.886" height="179.45" data-sentry-element="foreignObject" data-sentry-source-file="academy_user_border.tsx">
          <div style={{
          backdropFilter: "blur(21.05px)",
          clipPath: "url(#bgblur_0_172_107_clip_path)",
          height: "100%",
          width: "100%"
        }}></div>
        </foreignObject>
        <path d="M71.0001 323C326.5 307 401.214 313.487 515.377 258.21L502.84 350.692L71.0001 323Z" fill="#BEBDF7" fillOpacity="0.88" stroke="white" strokeOpacity="0.5" strokeWidth="2" data-sentry-element="path" data-sentry-source-file="academy_user_border.tsx" />
      </g>
      <defs data-sentry-element="defs" data-sentry-source-file="academy_user_border.tsx">
        <clipPath id="bgblur_0_172_107_clip_path" transform="translate(-28.8316 -214.4)" data-sentry-element="clipPath" data-sentry-source-file="academy_user_border.tsx">
          <path d="M71.0001 323C326.5 307 401.214 313.487 515.377 258.21L502.84 350.692L71.0001 323Z" data-sentry-element="path" data-sentry-source-file="academy_user_border.tsx" />
        </clipPath>
      </defs>
    </svg>;
};
export default AcademyUserBorder;